import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding: 24px;
  background: #ffffff;
  border-radius: 20px;
  width: 100%;
`;
